import React from "react";
import {categoriesV2} from "../utils/dictionaries/Categories";
import {tipiDocumento} from "../utils/arrays/Generics";

export const IT = {
	CONTATTACI_INFO_DIALOG: <React.Fragment>
		Utilizza il seguente modulo per la ricerca di informazioni in ambito
		sanitario da te
		desiderate navigando tra le varie domande e risposte.<br/>
		Non hai trovato quello che cercavi? Apri una richiesta indicando qual è il motivo per cui desideri
		contattare l'Asl.<br/>
	</React.Fragment>,

	CONTATTACI_INFORMATIVA_PRIV_2_: " e sulle rispettive pagine web delle varie Asl",
	CONTATTACI_INFORMATIVA_PRIVACY: <React.Fragment>
		<b>Informativa e privacy</b><br/>

		Gentile Sig./Sig.ra,<br/>

		I dati personali e/o sanitari che conferirà con la compilazione del presente modulo on line saranno trattati
		utilizzando modalità manuali, informatiche e telematiche, nel rispetto e nei limiti stabiliti dalla normativa
		vigente nazionale (D.Lgs. 196/2003, Codice in materia di Protezione dei Dati) e comunitaria (Regolamento Generale
		sulla Protezione dei Dati Personali, n. 679/2016, GDPR).
		<br/>
		Ocean.aslcittaditorino.it tratta i dati personali e sanitari in relazione ai servizi offerti attraverso il proprio
		sito Web, esclusivamente per le finalità assegnategli che rientrano nei compiti istituzionali e di interesse
		pubblico o per gli adempimenti previsti da norme di legge o di regolamento.
		<br/>
		Con l’uso o la consultazione del presente sito i visitatori e gli utenti approvano esplicitamente la presente
		informativa privacy e acconsentono al trattamento dei loro dati personali, compresa l’eventuale diffusione a terzi
		ove necessaria per l’erogazione di un servizio.
		<br/>
		DICHIARAZIONE DI PRESA VISIONE DELL’INFORMATIVA PRIVACY. Dichiaro di avere letto e preso conoscenza delle
		informazioni, rese ai sensi dell’art. 13 del Regolamento UE 2016/679, relative al trattamento dei miei dati
		personali, pubblicate alla pagina web {" "}
	</React.Fragment>,

	CONTATTACI_INFO_CALL_RESPONSE: <React.Fragment>
		Riceverai una chiamata entro <b>48 ore</b> dal Callcenter dell'ASL Città di Torino, rimani in
		attesa e resta a disposizione.
	</React.Fragment>,
	CONTATTACI_INFO_TICKT_RESPONSE: <React.Fragment>
		Riceverai una mail da Atlantis (no-reply@atlantisapp.it) nella quale troverai un
		link che ti rimanderà ad una sezione di Atlantis dalla quale potrai verificare lo stato ed eventualmente
		modificare il tuo ticket aggiungendo elementi (note ed allegati). <br/>
		Un operatore prenderà in carico il tuo ticket e ti risponderà entro <b>48 / 72 ore</b>.
	</React.Fragment>,

	CONTATTACI_RIENTRO_ALLEGATI: <React.Fragment>
		Allega, secondo le specifiche esigenze, uno o più dei seguenti documenti (inclusi quelli
		relativi
		ad eventuali compagni di viaggio):<br/>
		<ul>
			<li>Attestazione del completamento del ciclo vaccinale anti-SARS-CoV-2</li>
			<li>Documentazione di avvenuta guarigione da Covid-19, con contestuale cessazione
				dell’isolamento
			</li>
			<li>Referto di effettuazione, nelle 48 ore (o 72 ore a seconda del Paese da cui provieni)
				antecedenti
				all’ingresso in Italia, di test antigenico rapido o molecolare con esito negativo al virus
				SARS-CoV-2
			</li>
			<li>Dichiarazione del datore di lavoro per gli spostamenti dei dipendenti</li>
			<li>Deroga Ministero della Salute</li>
		</ul>
	</React.Fragment>,

	CONTATTACI_SANSIONI_ALLEGATI: <React.Fragment>
		Al fine di valutare l’insussistenza dell’obbligo vaccinale o l’impossibilità di adempiervi le chiediamo di allegare:<br/>
		<ul>
			<li>Copia della comunicazione di avvio del procedimento sanzionatorio, da cui si evincano il numero del documento
				e i dati anagrafici del soggetto
			</li>
			<li>un documento di identità e la tessera sanitaria
			</li>
			<li>eventuale documentazione attestante la vaccinazione, la pregressa infezione da Covid19 o l’esenzione ricevuta
			</li>
		</ul>
	</React.Fragment>,

	CONTATTACI_ESONERO_ALLEGATI: <React.Fragment>
		Allega, secondo le specifiche esigenze, uno o più documenti che attesti quando dichiarato come sottocategoria:
		<i>ad esempio se sei un soggetto ipersensibile allega un documento che attesti l'ipersensibilità ad uno o più
			principi attivi da te indicati</i>.<br/>
		<b>NB: É necessario allegare almeno un documento e copia del documento d'identità!</b>
	</React.Fragment>,

	QUESTION_YES: "sì",
	QUESTION_NO_: "no",

	// [categoriesV2[0].label]: "Vaccinazioni",
	// [categoriesV2[1].label]: "Esoneri vaccinali",
	// /*[categoriesV2[2].label]: "Covid 19",*/
	// [categoriesV2[3].label]: "Tamponi",
	// /*[categoriesV2[4].label]: "Tamponi rapidi",*/
	// [categoriesV2[5].label]: "Isolamento (Caso positivo)",
	// /*[categoriesV2[6].label]: "Quarantena (Contatto)",*/
	// [categoriesV2[7].label]: "Comunità",
	// [categoriesV2[8].label]: "Rientro in Italia",
	// [categoriesV2[9].label]: "Certificazione verde COVID-19",
	// [categoriesV2[10].label]: "Scuole",
	// [categoriesV2[11].label]: "Emergenza Ucraina",
	[categoriesV2[12].label]: "Informazioni Generali",

	// [categoriesV2[1].subCategories[0].label]: "Ipersensibilità",
	// [categoriesV2[1].subCategories[1].label]: "Reazione allergica grave",
	// [categoriesV2[1].subCategories[2].label]: "Sindrome di Guillain-Barré",
	// [categoriesV2[1].subCategories[3].label]: "Miocardite e pericardite",
	// [categoriesV2[1].subCategories[4].label]: "Terapia immunosoppressiva",
	// [categoriesV2[1].subCategories[5].label]: "Asma non controllato",
	// [categoriesV2[1].subCategories[6].label]: "Stato febbrile acuto grave/invalidante o da un'infezione acuta",
	// [categoriesV2[1].subCategories[7].label]: "Malattia acuta severa non differibile",
	// [categoriesV2[1].subCategories[8].label]: "Gravidanza",
	// [categoriesV2[1].subCategories[9].label]: "Altro",
	//
	// [categoriesV2[0].subCategories[0].label]: "Annullamento appuntamento",
	// [categoriesV2[0].subCategories[1].label]: "Spostamento appuntamento",
	// [categoriesV2[0].subCategories[2].label]: "Dose booster",
	// [categoriesV2[0].subCategories[3].label]: "Comunicazione vaccinazione effettuata in un 'altra Regione Italiana",
	// /*[categoriesV2[0].subCategories[4].label]: "Emergenza Ucraina",*/
	// [categoriesV2[0].subCategories[4].label]: "Sanzioni",
	// [categoriesV2[0].subCategories[5].label]: "Altro",
	//
	// /*[categoriesV2[2].subCategories[0].label]: "Segnalazione positivo",
	// [categoriesV2[2].subCategories[1].label]: "Segnalazione contatto positivo",
	// [categoriesV2[2].subCategories[2].label]: "Intervista epidemiologica",
	// [categoriesV2[2].subCategories[3].label]: "Altro",*/
	//
	// [categoriesV2[3].subCategories[0].label]: "Richiesta referto tamponi",
	// [categoriesV2[3].subCategories[1].label]: "Tamponi molecolari",
	// [categoriesV2[3].subCategories[2].label]: "Altro",
	//
	// /*[categoriesV2[4].subCategories[0].label]: "Segnalazione tampone rapido",
	// [categoriesV2[4].subCategories[1].label]: "Altro",*/
	//
	// [categoriesV2[5].subCategories[0].label]: "Ordinanze di isolamento",
	// [categoriesV2[5].subCategories[1].label]: "Certificato di fine isolamento",
	// [categoriesV2[5].subCategories[2].label]: "Certificato di inizio isolamento",
	// [categoriesV2[5].subCategories[3].label]: "Segnalazioni di ordinanza errate",
	// [categoriesV2[5].subCategories[4].label]: "Modifica ordinanza",
	// [categoriesV2[5].subCategories[5].label]: "Cambio di domicilio dell'isolamento",
	// [categoriesV2[5].subCategories[6].label]: "Altro",
	//
	// /*[categoriesV2[6].subCategories[0].label]: "Ordinanze di quarantena",
	//  [categoriesV2[6].subCategories[1].label]: "Certificato di fine quarantena",
	//  [categoriesV2[6].subCategories[2].label]: "Certificato di inizio quarantena",
	//  [categoriesV2[6].subCategories[3].label]: "Segnalazioni di ordinanza errate",
	//  [categoriesV2[6].subCategories[4].label]: "Modifica ordinanza",
	//  [categoriesV2[6].subCategories[5].label]: "Cambio di domicilio della quarantena",
	//  [categoriesV2[6].subCategories[6].label]: "Altro",*/
	//
	// [categoriesV2[7].subCategories[0].label]: "Segnalazione positivi",
	// [categoriesV2[7].subCategories[1].label]: "Contatto stretto",
	// [categoriesV2[7].subCategories[2].label]: "Tamponi",
	// [categoriesV2[7].subCategories[3].label]: "Deleghe",
	// [categoriesV2[7].subCategories[4].label]: "Trasferimento",
	// [categoriesV2[7].subCategories[5].label]: "Intervento USCA",
	// [categoriesV2[7].subCategories[6].label]: "Altro",
	//
	// [categoriesV2[8].subCategories[0].label]: "Segnalazione rientro",
	// [categoriesV2[8].subCategories[1].label]: "Locator",
	// [categoriesV2[8].subCategories[2].label]: "Informazioni generali",
	// [categoriesV2[8].subCategories[3].label]: "Invio referto",
	// [categoriesV2[8].subCategories[4].label]: "Altro",
	//
	// [categoriesV2[9].subCategories[0].label]: "Certificazione verde post vaccino",
	// [categoriesV2[9].subCategories[1].label]: "Certificazione verde post guarigione",
	// [categoriesV2[9].subCategories[2].label]: "Altro",
	//
	// [categoriesV2[10].subCategories[0].label]: "Segnalazione alunno positivo",
	// [categoriesV2[10].subCategories[1].label]: "Segnalazione docente positivo",
	// [categoriesV2[10].subCategories[2].label]: "Informazioni generali",
	// [categoriesV2[10].subCategories[3].label]: "Altro",
	//
	// [categoriesV2[11].subCategories[0].label]: "Vaccinazioni",
	// [categoriesV2[11].subCategories[1].label]: "Tamponi",
	// [categoriesV2[11].subCategories[2].label]: "Altro",

	[categoriesV2[12].subCategories[0].label]: "Altro",

	OCEAN__MAIN_GLOBAL_THEMA_TEXT: "Entra negli abissi di Atlantis",
	OCEAN__GLOBAL_THEMA_TEXT_DARK: "Riemergi dagli abissi profondi",
	OCEAN__GLOBAL_SEARCH_MAINTEXT: "Cerca",
	OCEAN__GLOBAL_NON_SPECIFICATO: "Non specificato/a",
	OCEAN__GLOBAL_REQUIRED_FILES_: "Questo campo è obbligatorio",
	OCEAN__GLOBAL_NOT_VALID_FILES: "Il valore inserito non è valido",
	OCEAN__GLOBAL_SELECT_DATE_INP: "Clicca per selezionare una data",
	OCEAN__GLOBAL_SELECT_DATE_ERR: "Inserisci una data corretta",
	OCEAN__GLOBAL_SELECT_DATE_MAX: "La data è successiva alla data massima",
	OCEAN__GLOBAL_SELECT_DATE_MIN: "La data è precedente alla data minima",
	OCEAN__GLOBAL_SELECT_DATE_TOD: "OGGI",
	OCEAN__GLOBAL_SELECT_DATE_CAN: "CANCELLA",

	CONTATTACI_CHANGE_LANG_BUTTON: "Cambia lingua",
	CONTATTACI_TITLE__MAIN_PAGE__: "Contatta la tua Asl!",
	CONTATTACI_BUTN__CLOSE_DIALOG: "Ok, chiudi",
	CONTATTACI_DESCR_PROBL_INPUT_: "Descrivi la tua problematica",
	CONTATTACI_RETURN_HOME_BUTTON: "Torna alla home",
	CONTATTACI_LINK__UTILI__TEXT_: "Link utili per la categoria",
	CONTATTACI_LINK_UTILI_TOOLTIP: "Clicca per aprirlo in un'altro tab",
	CONTATTACI__NEED__MORE__HELP_: "Non è quello che stavi cercando? Hai bisogno di più aiuto?",
	CONTATTACI__NEED__MORE_ESONER: "Apri una richiesta di esonero dalla vaccinazione",
	CONTATTACI__TRY__THIS__ALTERN: "Prova con queste proposte",
	CONTATTACI_TOOLTIP_RESPO_TEXT: "Ti risponderemo entro 48 ore",
	CONTATTACI_OPEN__TICKET__FORM: "Apri una richiesta",
	CONTATTACI_OPEN_TICKET_SUBTEX: "Ricevi una risposta dagli operatori",
	CONTATTACI__RICEVI__CHIAMATA_: "Ricevi una chiamata",
	CONTATTACI__RICEVI__SUBT_CALL: "Ricevi una chiamata dagli operatori",
	CONTATTACI_OPEN_TICKET_TITLE_: "Apri una richiesta",
	CONTATTACI_FARM_TICKET_TITLE_: "Farmacie convenzionate",
	CONTATTACI_REQUIRE_CALL_TITLE: "Ricevi una chiamata",
	CONTATTACI__BENVENUTO__TITLE_: "Benvenuto su Atlantis!",
	CONTATTACI__CONFERMO_PRIVACY_: "Confermo",
	CONTATTACI_READ_CONFIRM_PRIV_: "Ho letto integralmente e compreso l'informativa sul trattamento dei dati personali",
	CONTATTACI__SEND_REQUEST_LBL_: "Invia richiesta",
	CONTATTACI__SEND_TICKET__LBL_: "Invia ticket",

	TICKET_SELECT_CATEGORY_LABEL_: "Seleziona una categoria",
	TICKET_SELECT_SUBCATEG_LABEL_: "Quale di queste sottocategorie?",
	TICKET_VACCINI_REGIONE_LABEL_: "Regione in cui hai effettuato il vaccino",
	TICKET_VACCINI_TIPO_VAX_LABEL: "Tipo di vaccino",
	TICKET_TAMPONE_DATA_ESITO_LBL: "Data del tampone",
	TICKET_TAMPONE_LABORATO_LABEL: "Laboratorio",
	TICKET_VACCINI_SANZIONI_LABEL: "N° Documento procedimento sanzionatorio",
	TICKET_ORDINANZA_VECCHIO_DOM_: "Vecchio domicilio",
	TICKET_ORDINANZA_NUOVO__DOM__: "Nuovo domicilio",
	TICKET_SCUOLA__NOME_ISTITUTO_: "Nome istituto",
	TICKET_COMUNITA_NOME_COMUNITA: "Nome comunità",
	TICKET_ESONERO_NOME_ECCEPIENT: "Elenca i principi o eccipienti a cui sei ipersensibile",
	TICKET_ESONERO__DATA__VACCINO: "Data vaccino",
	TICKET_ESONERO__HUB_VACCINALE: "Hub vaccinale",
	TICKET_ESONERO_TIPO_MALATTIA_: "Tipo malattia acuta severa",
	TICKET_MESSAGGIO_DEL_TICKET__: "Dettaglio/Note della richiesta",
	TICKET_INPUT_FILE__MULTIPLE__: "Clicca o trascina dei file nell'area tratteggiata.",
	TICKET_INPUT__FILE__SINGLEF__: "Clicca o trascina un file nell'area tratteggiata",
	TICKET_INPUT__FILE__TOOLTIP__: "Per caricarne più di uno per volta hai due opzioni: se sei da PC con il tasto Ctrl o trascinane più di uno per volta; se sei da smartphone tenendo premuto su più file. NB: puoi comunque caricarne uno per volta trascinandone uno alla volta",
	TICKET_INPUT__REMOVE__FILES__: "Rimuovi questo allegato dal ticket",
	TICKET_INPUT_FILE_MAX_SIZE_LB: "Attenzione: non è possibile caricare file con peso superiore a 500MB!",

	ANAGRAFICA_FISRT_TEXT_TITLE__: "Compila il form di seguito indicato seguendo le istruzioni:",
	ANAGRAFICA_FISRT_TEXT_SUBTITL: "Tutti i campi contrassegnati da \"*\" sono obbligatori. In caso tu non abbia a disposizione un\n" +
		"\t\t\t\t\tindirizzo email o un telefono ti invito ad indicarne uno di una persona molto vicina a te (moglie,\n" +
		"\t\t\t\t\tmarito, figli, ...). Se non possiedi un codice fiscale usa una delle alternative proposte (metodo\n" +
		"\t\t\t\t\td'identificazione) ed indicane il valore nel campo \"Valore documento\".",

	ANAGRAFICA__CODICE__FISCALE__: "Codice fiscale",
	ANAGRAFICA__CELLULARE__1__LBL: "Cellulare",
	ANAGRAFICA__METODO_IDENTIFIC_: "Metodo d'identificazione",
	ANAGRAFICA__VALORE_DOCUMENTO_: "Numero documento",
	ANAGRAFICA__NAME_LBL: "Nome",
	ANAGRAFICA__SURNAME_: "Cognome",
	ANAGRAFICA__EMAIL___: "Email (non PEC)",
	ANAGRAFICA__ASL_DOM_: "Ufficio/Azienda",
	ANAGRAFICA__ASL_RES_: "Asl residenza",

	[tipiDocumento[0].label]: "Carta d'identità",
	[tipiDocumento[1].label]: "Patente",
	[tipiDocumento[2].label]: "Passaporto",
	[tipiDocumento[3].label]: "Codice STP",

	SEGNALAZIONE_POSITIVO_ALERT_TITLE: "Come utilizzo il ticket?",
	SEGNALAZIONE_POSITIVO_ALERT_INFO_: <React.Fragment>
		Indica nell'anagrafica del ticket (i campi sovrastanti) la tua anagrafica e rispondi qui sotto alle domande
		che ti vengono poste in modo sincero e responsabile.<br/>
		Nell'ultima sezione ti sarà chiesto di indicare i contatti che hai avuto: <b>INDICA LE PERSONE CON CUI SEI
		STATO A CONTATTO NELLE ULTIME 48 ORE O I LUOGHI CHE HAI FREQUENTATO</b>
	</React.Fragment>,

	SEGNALAZIONE_POSITIVO_TIPO_TAMPONE: "Tipo tampone",
	SEGNALAZIONE_POSITIVO_DATA_TAMPONE: "Data tampone",
	SEGNALAZIONE_POSITIVO_ESIT_TAMPONE: "Esito tampone",

	SINTOMI_RICOVERATO_1a: "Sei ricoverato presso qualche struttura?",
	SINTOMI_STRUTTURA_NOM: "Indica il nome della struttura",
	SINTOMI_PRESENTA_SINT: "Ti sono comparsi sintomi quali febbre, tosse, difficoltà respiratorie?",
	SINTOMI_IMMUNODEPRESS: "Sei un soggetto immunodepresso?",
	SINTOMI_PATOLOGIE_CRO: "Hai patologie croniche?",
	SINTOMI_EFFETTUAT_VAX: "Hai effettuato il vaccino contro il SARS-CoV-2?",

	RISCHIO_SCARICATO_APP: "Hai scaricato l'applicazione immuni?",
	RISCHIO_VIAGGI_ESTERO: "Hai effettuato viaggi all'estero nelle ultime 48h?",
	RISCHIO_VIAGGI_REGION: "Hai effettuato viaggi al di fuori della tua regione nelle ultime 48h?",
	RISCHIO_LISTA_REGIONI: "Lista regioni visitate",
	RISCHIO_LISTA_PAESI_E: "Lista paesi visitati",

	RIENTRO_EFFETT_VAXCOV: "Hai effettuato il vaccino contro il SARS-CoV-2?",
	RIENTRO_EFFETT_TAMPON: "Hai effettuato un tampone?",
	RIENTRO_VACCINO_DOS1A: "Data prima dose",
	RIENTRO_VACCINO_DOS1T: "Tipo di vaccino 1^ dose",
	RIENTRO_VACCINO_DOS2A: "Data seconda dose",
	RIENTRO_VACCINO_DOS2T: "Tipo di vaccino 2^ dose",
	RIENTRO_VACCINO_DOS3A: "Data terza dose",
	RIENTRO_VACCINO_DOS3T: "Tipo di vaccino 3^ dose",
	RIENTRO_DATA_PREVISTA: "Data rientro in Italia",
	RIENTRO_MOTIVAZIONE_R: "Motivo del rientro",
	RIENTRO_VIAGG_COMPAGN: "Hai viaggiato in compagnia?",
	RIENTRO_COMPAGNO_LBL_: "Compagno",
	RIENTRO_MESSAGGIO_CMP: "É obbligatorio indicare un documento d'identificazione del compagno",
	RIENTRO_AGGIUN_FRIEND: "Aggiungi compagno",
	RIENTRO_RIMUOV_FRIEND: "Rimuovi compagno",
}

//APP
export const APP_NAME = "Ocean";

//ANAGRAFICA
export const CODICE_FISCALE = "Codice fiscale";
export const STP = "Codice STP";
export const CELLULARE = "Cellulare";
export const NOME = "Nome";
export const COGNOME = "Cognome";
export const EMAIL = "Email";
export const DATA_NASCITA = "Data nascita";
export const SESSO = "Sesso";
export const DOMICILIO = "Indirizzo di domicilio";
export const RESIDENZA = "Indirizzo di residenza";

//ERROR
export const GENERIC_ERROR = "Ops, qualcosa è andato storto, se questo errore persiste contatta gli sviluppatori";

//APPBAR
export const BUG_TEXT = "Segnala un bug tramite il form segnalazione ed indicando come categoria assistenza tecnica";
export const OCEAN__MAIN_GLOBAL_THEMA_TEXT = "Entra negli abissi di Atlantis";
export const OCEAN__GLOBAL_THEMA_TEXT_DARK = "Riemergi dagli abissi profondi";
export const MESSAGE_TEXT = "Funzionalità non ancora presente ... mi spiace :(";
export const PROFILE_TEXT = "Apri area personale";

//NO DATA
export const NO_DATA = "Non sono presenti dati";

//CONTATTO
export const COME_CONTATTO = "Com'è avvenuto il contatto?";

//INFO LAVORO
export const ULTIMA_FREQ = "Data ultima frequentazione";
export const CLASSE = "Classe";
export const SEZIONE = "Sezione";
export const PROFESSIONE = "Professione";
export const RSPP = "RSPP / Datore di lavoro";
export const AZIENDA = "Azienda";

//INFO MEDICO
export const NOME_MEDICO = "Nome medico";
export const COGNOME_MEDICO = "Cognome medico";
export const CELLULARE_MEDICO = "Cellulare";
export const EMAIL_MEDICO = "Email";
export const FISSO_MEDICO = "Telefono fisso";

//RICOVERATO VACCINO
export const EFFETTUATO_TAMPONE_1a = "Hai effettuato un tampone?";
export const ESITO_TAMPONE = "Esito tampone";
export const DATA_TAMPONE = "Data tampone";
export const RICOVERATO_3a = "É ricoverato presso qualche struttura?";
export const STRUTTURA_NOME = "Indica il nome della struttura";
export const EFFETTUATO_VACCINO_1a = "Hai effettuato il vaccino contro il SARS-CoV-2?";
export const DATA_PRIMA_DOSE = "Data prima dose";

//RISCHIO CONTAGIO
export const SCARICATO_IMMUNI_3a = "Ha scaricato l'applicazione immuni?";
export const VIAGGI_ESTERO_14GG_3a = "Ha effettuato viaggi all'estero negli ultimi 14 giorni?";
export const LISTA_PAESI_ESTERI = "Lista paesi visitati";
export const VIAGGI_REGIONI_14GG_3a = "Hai effettuato viaggi al di fuori della tua regione negli ultimi 14 giorni?";
export const LISTA_REGIONI_VISITATE = "Lista Regioni visitate";
export const ESPOSTO_RISCHIO_1a = "Sei stato esposto ad una possibile fonte di rischio contagio?";
export const ESPOSTO_RISCHIO_3a = "É stato esposto ad una possibile fonte di rischio contagio?";
export const VIVI_SOLO_1a = "Vivi da solo?";
export const VIVI_SOLO_3a = "Vive da solo?";
export const CORRETTO_ISOLAMENTO_1a = "Riesci a garantire un corretto isolamento?";
export const CORRETTO_ISOLAMENTO_3a = "Riesce a garantire un corretto isolamento?";
export const DATA_INIZIO_ISOLAMENTO = "Data inizio isolamento";

//SINTOMI PATOLOGIE
export const PRESENTA_SINTOMI_3a = "Gli sono comparsi sintomi quali febbre, tosse, difficoltà respiratorie?";
export const COMPARSA_SINTOMI = "Comparsa sintomi";
export const IMMUNODEPRESSO_3a = "É un soggetto immunodepresso?";
export const PATOLOGIE_3a = "Ha patologie croniche?";
